/* eslint-disable prettier/prettier, linebreak-style, indent */
/* global jQuery */
class Carousel {
  constructor() {
    this.selectors = {
      slider: '.js-carousel',
    };

    this.DOM = {
      sliders: document.querySelectorAll(this.selectors.slider),
    };

    this.classes = {};

    window.addEventListener('DOMContentLoaded', () => {
      this.init();
    });
  }

  init() {
    if (this.DOM.sliders.length) {
      this.DOM.sliders.forEach((slider) => {
        const { infinite } = slider.dataset;
        jQuery(slider).slick({
          slidesToShow: 1,
          arrows: false,
          dots: true,
          dotsClass: 'c-carousel__dots',
          autoplay: false,
          infinite: infinite !== '0',
          adaptiveHeight: true,
        });
      });
    }
  }
}

export default new Carousel();
